import React, { Suspense } from "react";
import { MatxLoading } from "monitoring-tool";

const MatxSuspense = props => {
  return <Suspense fallback={<MatxLoading />}>{props.children}</Suspense>;
};

export default MatxSuspense;
